<template>
  <component class="icon" :is="'ion-' + name" :w="width" :h="height"/>
</template>

<script>
  import IonCloseCircle from 'vue-ionicons/dist/md-close-circle.vue';

  export default {
    name: 'WIcon',
    props: {
      name: String,
      width: String,
      height: String,
    },
    components: {
      IonCloseCircle,
    },
  };
</script>
